<template>
  <div class="overflow-hidden card h-100">
    <div class="p-3 card-body">
      <div class="col-12">
        <div class="d-flex">
          <div class="ms-3">
            <div class="mb-0 text-sm text-uppercase text-primary">
              {{ title }}
            </div>
            <span class="mb-0 mt-1 header">{{ header }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mx-0 px-0 mt-3">
          <div class="d-flex flex-row ms-3">
            <user-report-item
              v-for="(profile, idx) in profiles"
              :key="profile.dna_profile_name"
              :name="profile.dna_profile_name"
              :confidence="profile.confidence"
              :dna-score="profile.dna_score"
              :wellness-score="profile.wellness_score"
              :profile-score="profile.profile_score"
              :bg-color="getBgColor(idx)"
              :genetic-contributions="profile.dna_contributions"
              :wellness-contributions="profile.wellness_contributions"
              :img-path="`/img/${profile.dna_profile_name}.jpg`"
            />
          </div>
        </div>
      </div>

      <!-- Loading overlay -->
      <div
        v-if="showLoader"
        class="position-absolute top-50 start-50 translate-middle opacity-50"
      >
        Loading Recommended Profiles...
      </div>

      <!-- No data overlay -->
      <div
        v-if="showNoDataOverlay"
        class="bg-dark position-absolute top-0 start-0 h-100 w-100 opacity-50"
      ></div>

      <div
        v-if="showNoDataOverlay"
        class="bg-secondary position-absolute top-50 start-50 translate-middle w-100 opacity-75"
      >
        <div
          class="d-flex flex-column h-100 align-items-center justify-content-center p-3"
        >
          <h3>Not Profiled</h3>
          <div class="text-lighter font-weight-bold">
            Take a DNA test to see results
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserReportItem from "./UserReportItem.vue";

export default {
  name: "UserReports",
  components: {
    UserReportItem,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    header: {
      type: String,
      default: "",
    },
    udid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      results: [],
      profiles: [],
      hasProfiles: false,
      showLoader: true,
    };
  },
  computed: {
    showNoDataOverlay() {
      return !this.showLoader && !this.hasProfiles;
    },
  },
  watch: {
    udid(newValue) {
      if (newValue) this.getUserDnaData(newValue);
    },
  },
  mounted() {
    if (this.udid) this.getUserDnaData(this.udid);
  },
  methods: {
    getBgColor(idx) {
      return idx % 2 == 0 ? "transparent" : "rgba(255, 255, 255, 0.05)";
    },
    getUserDnaData(udid) {
      if (udid) {
        this.$store
          .dispatch("data/userDnaProfiles", {
            udid: udid,
            dna_profile_id: "",
          })
          .then((data) => {
            if (data) {
              this.getProfiles(data.data);
            }
          });
      } else {
        // no udid, redirect user to error page
        this.$router.push({ name: "Error Error500" });
      }
    },
    getProfiles(results) {
      if (results && results.length > 0) {
        // Sort list in descending order based on profile score
        results.sort((a, b) => b.dna_score - a.dna_score);
        this.profiles = results;

        this.hasProfiles = true;
        this.showLoader = false;
      } else {
        this.hasProfiles = false;
        this.showLoader = false;
      }
    },
    calculateProfileScore(contributions) {
      let score = 0;
      contributions.forEach((element) => {
        score += element.score;
      });
      return score;
    },
  },
};
</script>

<style scoped>
.header {
  font-weight: 100 !important;
  font-size: 1.2rem;
}
</style>